import React from "react";
import Breadcrumb from "../components/Breadcrumb";
import EventDetailLayer from "../components/EventDetailLayer";

const EventDetailPage = () => {
  return (
    <>
      <Breadcrumb title="Event Details" />
      <EventDetailLayer />
    </>
  );
};

export default EventDetailPage;